import { Injectable } from "@angular/core";
import { User } from "./core/user";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class StorageService {
    private tokenKey = 'token';

    private isTokenExist: boolean;

    isSensitiveDataExist: BehaviorSubject<boolean>;

    constructor() {
        this.isSensitiveDataExist = new BehaviorSubject<boolean>(false);
        this.init();
    }

    setToken(value: string) {
        localStorage.setItem(this.tokenKey, value);
        this.isTokenExist = true;

        this.isSensitiveDataExist.next(this.isTokenExist);
    }

    getToken(): string {
        let value = localStorage.getItem(this.tokenKey);
        return value;
    }

    clear() {
        localStorage.clear();
        this.isTokenExist = false;

        this.isSensitiveDataExist.next(this.isTokenExist);
    }

    private init() {
        let tokenValue = localStorage.getItem(this.tokenKey);
        this.isTokenExist = !!tokenValue;

        this.isSensitiveDataExist.next(this.isTokenExist);
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/storage.service.ts